import React from "react";

export default function DocTypes() {
  return (
      <div>Dokumentum típusok</div>
  );
}
